import type { PartnerGeneralResponseDto } from "Infrastructure/Api/Api";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Grid2, Typography } from "@mui/material";

type AssignedPartnerWidgetProps = {
	partner: PartnerGeneralResponseDto;
};

export function AssignedPartnerWidget({ partner }: AssignedPartnerWidgetProps) {
	const { fullName, email, phone } = partner;

	return (
		<BaseCard title="Assigned partner">
			<Grid2 container>
				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						Name
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{fullName}
					</Typography>
				</Grid2>

				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						Phone
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{phone}
					</Typography>
				</Grid2>

				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						Email
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{email}
					</Typography>
				</Grid2>
			</Grid2>
		</BaseCard>
	);
}
